import { render, staticRenderFns } from "./FullModalLayout.vue?vue&type=template&id=10463d54&scoped=true&"
import script from "./FullModalLayout.vue?vue&type=script&lang=js&"
export * from "./FullModalLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10463d54",
  null
  
)

export default component.exports